import { render, staticRenderFns } from "./global-events.vue?vue&type=template&id=2603887e&scoped=true&"
import script from "./global-events.vue?vue&type=script&lang=js&"
export * from "./global-events.vue?vue&type=script&lang=js&"
import style0 from "./global-events.vue?vue&type=style&index=0&id=2603887e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603887e",
  null
  
)

export default component.exports